import React, { useState, useEffect } from "react";
import { Modal,Select, Typography, Button, Input } from "antd";
import * as orderManagementActions from "../../../../../../redux/actions/orderManagement.actions";
import * as cancellationReasonActions from "../../../../../../redux/actions/cancellationReason.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { TextArea } = Input;
const { Text } = Typography;
const { Option } = Select;

const OrderCancelConfirmation = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [postDataReason, setPostDataReason] = useState(null);
  const [Comment, setComment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cancellationReason, setCancellationReason] = useState(null);

  useEffect(() => {
    if(typeof props.orderCancelConfirmationData.data != "undefined" && props.orderCancelConfirmationData.data.reason){
      statusReason(props.orderCancelConfirmationData.data.reason)
    }
  })

  const statusReason = (Value) => {
    setPostDataReason(Value);
  };

  // const setCommentFunctionOnchange = (val) => {
  //   setComment(val);
  // };

  const statusSubmit = async () => {
    try {
      setMBtnLoading(true);
      await props.orderManagementActions.updateOrderStatusAction({
        orderId: props.overviewdashboardid,
        statusSlug: "cancel",
        reason: postDataReason,
        comment: Comment,
      },"Order Cancel")
    } catch (e) {} finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };

  const handleCancel = () => {props.setvisible(false)};

  return (
    <Modal
      title="Cancel Order Confirmation"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Do Not Cancel</Button>,
        <Button loading={MBtnLoading} onClick={statusSubmit} disabled={postDataReason == null}>Confirm Cancel</Button>,
      ]}
    >
      <Text>Order’s current status is Delivered. Are you sure you want to Cancel the order?</Text>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    cancellationReasonData: state.CancellationReasonReducer.cancellationReasonData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderCancelConfirmation);
